/** The list filter that applies the closing check's own rule, so a link opens exactly the items the modal counted. */
const UNINVOICED_FOR_CLOSING_FILTER = 'mf=id=isuninvoicedforclosing=true';

export function uninvoicedTimecardsUrl(matterId: number): string {
    return `/matter/${matterId}/timecards?${UNINVOICED_FOR_CLOSING_FILTER}`;
}

export function uninvoicedExpensesUrl(matterId: number): string {
    return `/matter/${matterId}/expenses?${UNINVOICED_FOR_CLOSING_FILTER}`;
}

export function invoiceUrl(invoiceId: number): string {
    return `/invoice/${invoiceId}`;
}

export function taskUrl(taskId: number): string {
    return `/task/${taskId}`;
}

export function experienceRecordUrl(experienceRecordId: number): string {
    return `/experience-records/${experienceRecordId}`;
}
